import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Success = () => {
  // const data = useLocation();

  // const text = data.state.textValidation;

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(-1);
  };
  return (
    <div className="notif2">
      <h1> Page 1</h1>

      <div className="input2">
        <button onClick={handleClick}> Retour</button>
      </div>
    </div>
  );
};

export default Success;
